(function () {
  const MAX_STORED = 20;

  function readList(key) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((id) => id != null && id !== '').map(String);
    } catch (err) {
      return [];
    }
  }

  function writeList(key, list) {
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) {
      return;
    }
  }

  function recordProduct(key, productId) {
    if (!productId) return;
    const id = String(productId);
    const list = readList(key).filter((existing) => existing !== id);
    list.unshift(id);
    if (list.length > MAX_STORED) list.length = MAX_STORED;
    writeList(key, list);
  }

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'shopify_recently_viewed';
      this.productsToShow = parseInt(this.dataset.productsToShow, 10) || 4;
      this.currentProductId = this.dataset.currentProductId || '';
      this.showSlider = this.dataset.showSlider === 'true';
      this.sectionId = this.dataset.sectionId || '';
      this.imageRatio = this.dataset.imageRatio || 'adapt';
    }

    connectedCallback() {
      if (this.currentProductId) {
        recordProduct(this.storageKey, this.currentProductId);
      }
      this.render();
    }

    getIdsToRender() {
      const all = readList(this.storageKey);
      const filtered = this.currentProductId
        ? all.filter((id) => id !== String(this.currentProductId))
        : all;
      return filtered.slice(0, this.productsToShow);
    }

    async render() {
      const ids = this.getIdsToRender();
      if (ids.length === 0) {
        this.hidden = true;
        return;
      }

      const query = ids.map((id) => `id:${id}`).join(' OR ');
      const url = `${window.Shopify.routes.root}search?view=recently-viewed&type=product&q=${encodeURIComponent(query)}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const html = await response.text();
        this.injectCards(html, ids);
      } catch (err) {
        console.warn('[recently-viewed-products] Failed to load products:', err);
        this.hidden = true;
      }
    }

    injectCards(html, ids) {
      const grid = this.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;

      grid.replaceChildren();

      const parser = new DOMParser();
      const doc = parser.parseFromString(`<ul>${html}</ul>`, 'text/html');
      const items = Array.from(doc.querySelectorAll('li.grid__item'));

      if (items.length === 0) {
        this.hidden = true;
        return;
      }

      const byId = new Map();
      items.forEach((li) => {
        const id = li.getAttribute('data-recently-viewed-id');
        if (id) byId.set(id, li);
      });

      const ordered = ids
        .map((id) => byId.get(String(id)))
        .filter(Boolean);

      const finalItems = ordered.length > 0 ? ordered : items;

      const useSlider = this.showSlider;
      const ratioPercent = this.imageRatio === 'portrait'
        ? '125%'
        : this.imageRatio === 'square'
          ? '100%'
          : null;

      finalItems.forEach((li, index) => {
        if (useSlider) {
          li.classList.add('slider__slide');
          li.id = `Slide-${this.sectionId}-${index + 1}`;
        }
        grid.appendChild(li);
      });

      if (ratioPercent) {
        grid.querySelectorAll('.card, .card__inner').forEach((el) => {
          el.style.setProperty('--ratio-percent', ratioPercent);
        });
      }

      this.hidden = false;

      if (useSlider) {
        const counter = this.querySelector('.slider-counter--total');
        if (counter) counter.textContent = finalItems.length;
        const buttons = this.querySelector('.slider-buttons');
        if (buttons) buttons.hidden = false;
      }

      this.dispatchEvent(
        new CustomEvent('recently-viewed:rendered', {
          bubbles: true,
          detail: { count: finalItems.length }
        })
      );
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
